import axios from 'axios'
import { Message } from 'element-ui'

// 创建 axios 实例
const service = axios.create({
    // baseURL: "https://uat.dellemc-solution.com",
    baseURL: window.location.hostname.includes('www') ? "https://www.dellemc-solution.com" : "https://uat.dellemc-solution.com" ,
    timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么
        return config
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => { 
        const res = response.data;
        // 如果返回的状态码不是200，说明接口请求失败
        if ((res.errCode&&res.errCode !== 0) || (res.result&&res.result !== 0)) {
            Message({
                message: res.msg || 'Request unsuccessful',
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(new Error(res.msg || 'Request unsuccessful'))
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error)
        Message({
            message: error.msg,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service